import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import moment from 'moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../containers/Common/TypeRadios';
import { DatePicker } from '../Common/datePicker';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import InventoryInfo from '../../containers/Purchase/inventoryInfo';
import { dateFormat, toFromDates } from '../Common/cleanDates';
import DateFormatter from '../Common/dateFormat';
import CashFormatter from '../Common/cashFormatter';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import {
  ROOT_URL, companyCodeTitle, isOCM, isOLG, isSUN, isSV, isVAK, isLAP, isUSPrideMulti, isAPD, isGGI
} from '../../actions/root_url';
import { isDst } from '../Common/NumberUtil';

const getBsStyle = (input, value) => (input == value ? 'success' : 'primary');

const renderRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');

  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className="radio">
          <label htmlFor="today-radio-filter">
            <input {...props.input} id="today-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="1" onClick={() => props.fetchPurchasingPerformance(1)} checked={props.input.value === '1'} />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className="radio">
          <label htmlFor="sevenDay-radio-filter">
            <input {...props.input} id="sevenDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="7" onClick={() => props.fetchPurchasingPerformance(7)} checked={props.input.value === '7'} />
              7 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className="radio">
          <label htmlFor="thirtyDay-radio-filter">
            <input {...props.input} id="thirtyDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="30" onClick={() => props.fetchPurchasingPerformance(30)} checked={props.input.value === '30'} />
              30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className="radio">
          <label htmlFor="ninetyDay-radio-filter">
            <input {...props.input} id="ninetyDay-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="90" onClick={() => props.fetchPurchasingPerformance(90)} checked={props.input.value === '90'} />
              90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className="radio">
          <label htmlFor="dateRange-radio-filter">
            <input {...props.input} id="dateRange-radio-filter" type="radio" disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      <Button bsStyle="primary">
        <Field name="FromDate" disabled={props.input.value !== '-1' || (props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} component={DatePicker} placeholder="Start" />
      </Button>
      <Button bsStyle="primary">
        <Field name="ToDate" disabled={props.input.value !== '-1' || (props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)} component={DatePicker} placeholder="End" />
      </Button>
    </ButtonToolbar>
  );
};

const renderPORadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-4');
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'All')}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input
              {...props.input}
              id="all-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="All"
              checked={props.input.value === 'All'}
              onClick={() => {
                /*
                  - Intended to not pass handleOnClick as a function to onClick
                  - handleOnClick needs an undefined value for @param days
                  - this rule should apply to all the buttons here inside renderPORadios
                */
                props.handleOnClick("All");
              }}
            />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Placed')}>
        <div className="radio">
          <label htmlFor="placed-radio-filter">
            <input
              {...props.input}
              id="placed-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="Placed"
              checked={props.input.value === 'Placed'}
              onClick={() => { props.handleOnClick("Placed"); }}
            />
            <Translate value="placed" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Received')}>
        <div className="radio">
          <label htmlFor="received-radio-filter">
            <input
              {...props.input}
              id="received-radio-filter"
              type="radio"
              name="statusFilterRadios"
              disabled={(props.purchasingPerformanceIsLoading || props.purchasingPerformanceByProductsIsLoading)}
              value="Received"
              checked={props.input.value === 'Received'}
              onClick={() => { props.handleOnClick("Received"); }}
            />
            <Translate value="received" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

const renderProductTypeRadios = props => (
  <div className="form-group" id="search-product-by">
    <label className="col-xs-3 search-by-max-width">
      <Translate value="search_by" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>
    <label className="col-xs-2 pl">
      <input
        {...props.input}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value={isOLG ? "item_no" : "ref_num"} />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="ml-lg" >
      <input
        {...props.input}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="description" />
    </label>
  </div>
);
class PurchasingPerformance extends Component {
  constructor() {
    super();
    this.state = {
      purchasingPerformance: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchasingPerformanceByProducts: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
        selectedIndexes: [],
      },
      SumPO: 0,
      activeKey: 1,
      showInventoryOpen: false,
      selectedInventoryRow: [],
      ProductNum: 0,
      days: '7',
      fromDate: undefined,
      toDate: undefined,
      suggestValue: '',
      productSearchType: 'ProductNum',
      totalPriceByPO: 0,
      finalPriceByPO: 0,
      totalPriceByProd: 0,
      totalQtyByProd: 0,
      receiveTotalPriceByProd: 0,
      receiveTotalQtyByProd: 0,
      //for generic radio filter
      POStatus: 'All',
      orderType: null,

    };
    this.fetchPurchasingPerformanceByDays = this.fetchPurchasingPerformanceByDays.bind(this);
    this.fetchPurchasingPerformanceByStatus = this.fetchPurchasingPerformanceByStatus.bind(this);
    this.openShowInventory = this.openShowInventory.bind(this);
    this.closeShowInventory = this.closeShowInventory.bind(this);
    this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.setUnitPrice = this.setUnitPrice.bind(this);
    this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('Days', '7', 'purchasingPerformance');
    this.props.setDefaultOfForm('POStatus', 'All', 'purchasingPerformance');
    this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    if (this.props.selectedCompany && this.props.selectedCompany.value) {
      this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
    }
    if (((isLAP || isUSPrideMulti || isAPD) || isGGI) && !this.props.Vendor_id) {
      this.fetchListWithFilters();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.purchasingPerformance && nextProps.purchasingPerformance != this.props.purchasingPerformance) {
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: nextProps.purchasingPerformance.Data };
      const SumPO = nextProps.purchasingPerformance.sum;
      const totalPriceByPO = nextProps.purchasingPerformance.Sum_Total_Price;
      const finalPriceByPO = nextProps.purchasingPerformance.Sum_Final_Price;
      const totalPriceByProd = nextProps.purchasingPerformance.Sum_Total_Price;
      const totalQtyByProd = nextProps.purchasingPerformance.Sum_Total_Quantity;
      const receiveTotalPriceByProd = nextProps.purchasingPerformance.Sum_Receive_Total_Price;
      const receiveTotalQtyByProd = nextProps.purchasingPerformance.Sum_Receive_Total_Quantity;
      if (this.state.activeKey === 1) {
        this.setState({ purchasingPerformance, totalPriceByPO, finalPriceByPO, SumPO });
      } else {
        this.setState({ purchasingPerformanceByProducts: purchasingPerformance, totalPriceByProd, receiveTotalPriceByProd, SumPO, totalQtyByProd, receiveTotalQtyByProd });
      }
    }

    if (nextProps.purchaseOrderPerformanceByProduct && nextProps.purchaseOrderPerformanceByProduct != this.props.purchaseOrderPerformanceByProduct) {
      const purchasingPerformanceByProducts = { ...this.state.purchasingPerformanceByProducts, rows: nextProps.purchaseOrderPerformanceByProduct.Data };
      const SumPO = nextProps.purchaseOrderPerformanceByProduct.sum;
      this.setState({ purchasingPerformanceByProducts, SumPO });
    }

    if (nextProps.purchaseOrderList && nextProps.purchaseOrderList != this.props.purchaseOrderList) {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: nextProps.purchaseOrderList };
      this.setState({ purchaseOrderDetail });
    }
    if (nextProps.Days && nextProps.Days != this.props.Days) {
      if (nextProps.Days !== '-1') {
        this.resetDateRange();
      }
      this.setState({ days: nextProps.Days });
    }
    if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
      // pass async callback for fetching with new filter
      this.setState({ fromDate: nextProps.FromDate }, this.fetchPurchasingPerformanceByDays);
    }
    if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
      // pass async callback for fetching with new filter
      this.setState({ toDate: nextProps.ToDate }, this.fetchPurchasingPerformanceByDays);
    }
    // if (nextProps.POStatus && nextProps.POStatus != this.props.POStatus) {
    //   let fromDate = '1900-01-01';
    //   let toDate = '3000-01-01';
    //   const productinfo = this.state.filterProductID;
    //   if (this.state.fromDate) {
    //     fromDate = this.formatDate(this.state.fromDate);
    //   }
    //   if (this.state.toDate) {
    //     toDate = this.formatDate(this.state.toDate);
    //   }
    //   if (this.state.activeKey == '1' && this.props.Vendor_id) {
    //     this.props.fetchPurchasePerformanceByFilter(this.state.days || 1, fromDate, toDate, 'show', nextProps.POStatus, this.props.Vendor_id);
    //   } else if (productinfo) {
    //     // this.props.fetchPurchasingPerformanceByProduct(this.state.days, fromDate, toDate, 'show', nextProps.POStatus, productinfo);
    //     this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.props.POStatus, null, productinfo);
    //   }
    // }
    if (nextProps.Vendor_id != this.props.Vendor_id) {
      // let fromDate = '1900-01-01';
      // let toDate = '3000-01-01';
      // if (this.state.fromDate) {
      //   fromDate = this.formatDate(this.state.fromDate);
      // }
      // if (this.state.toDate) {
      //   toDate = this.formatDate(this.state.toDate);
      // }
      // if (!nextProps.Vendor_id && this.state.activeKey == '1') {
      //   this.resetByPurchaseOrderData();
      // } else {
      //   this.fetchListWithFilters();
      //   // this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, nextProps.Vendor_id);
      // }
    }
    if (nextProps.selectedWarehouse.value != this.props.selectedWarehouse.value) {
      if ((isLAP || isUSPrideMulti || isAPD)) {
        this.fetchListWithFilters(nextProps.selectedWarehouse.value);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.searchType) {
      this.props.setDefaultSearchType('RefNum', 'purchasingPerformance');
    }
    if (prevProps.Vendor_id !== this.props.Vendor_id) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (this.state.fromDate) {
        fromDate = this.formatDate(this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = this.formatDate(this.state.toDate);
      }
      if (!this.props.Vendor_id && this.state.activeKey == '1') {
        this.resetByPurchaseOrderData();
        if ((isLAP || isUSPrideMulti || isAPD) || isGGI) {
          this.fetchListWithFilters();
        }
      } else {
        this.fetchListWithFilters();
        // this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, nextProps.Vendor_id);
      }
    }
    if (prevProps.selectedCompany !== this.props.selectedCompany) {
      this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
      this.props.changeFormValue('purchasingPerformance', 'Vendor_id', null);
      // this.fetchListWithFilters();
    }
    if (isGGI && prevProps.selectedCompany.value === this.props.selectedCompany.value && prevProps.selectedWarehouse !== this.props.selectedWarehouse) {
      this.fetchListWithFilters();
    }
  }

  renderDatePickers() {
    if (this.state.days == -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} maxDate={this.state.toDate || new Date()} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} minDate={this.state.fromDate || new Date('2016-01-01')} />
          </div>
        </div>
      );
    }
  }

  handleSelect(activeKey) {
    switch (activeKey) {
      case 1:
        this.setState({ activeKey });
        break;
      default:
        this.setState({ activeKey });
    }
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  // Used for new generic datePicker//////////////////////////////
  setToDate = (e) => {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState({ toDate: e });
  }

  setFromDate = (e) => {
    if (e > this.state.toDate) {
      return;
    }
    this.setState({ fromDate: e });
  }

  setToRangeSearch = (e) => {
    this.setState({ days: '-1' });
  }
  //////////////////////////////

  formatDate(date) {
    return dateFormat('YYYY-MM-DD', date);
  }

  getVendorOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: `${vendor.VendorNum} - ${vendor.Name}` });
    });
    return vendorOptions;
  }

  resetDateRange() {
    this.props.setDefaultOfForm('FromDate', null, 'purchasingPerformance');
    this.props.setDefaultOfForm('ToDate', null, 'purchasingPerformance');
  }

  resetByPurchaseOrderData(callback) {
    this.setState(prevState => ({
      ...prevState,
      purchasingPerformance: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      totalPriceByPO: 0,
      finalPriceByPO: 0,
    }), callback);
  }

  fetchPurchasingPerformanceByDays(days) {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    if (this.state.activeKey === 1 && (this.props.Vendor_id || ((isLAP || isUSPrideMulti || isAPD) || isGGI) && !this.props.Vendor_id)) {
      if (days === '-1' || days === -1) {
        this.setState({ days: days }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id);
        })
      } else {
        this.setState({ days:days, fromDate: undefined, toDate: undefined }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id);
        });
      }
    } else if (!((isLAP || isUSPrideMulti || isAPD) || isGGI) && this.state.activeKey === 1 && !this.props.Vendor_id) {
      alert('Please Select a Vendor Before you search');
    } else if (this.state.activeKey === 2 && productinfo) {
      if (days === '-1' || days === -1) {
        this.setState({ days: days }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo);
        })
      } else {
        this.setState({ days:days, fromDate: undefined, toDate: undefined }, () => {
          this.fetchListWithFilters();
          // this.props.fetchPurchasePerformanceByFilter(days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo);
        });
      }
    }
  }

  fetchPurchasingPerformanceByStatus(poStatus) {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    if (this.state.activeKey === 1 && (this.props.Vendor_id || ((isLAP || isUSPrideMulti || isAPD) || isGGI) && !this.props.Vendor_id)) {
      this.setState(
        { POStatus: poStatus },
        () => {
          this.fetchListWithFilters();
        }
      );
    } else if (!((isLAP || isUSPrideMulti || isAPD) || isGGI) && this.state.activeKey === 1 && !this.props.Vendor_id) {
      alert('Please Select a Vendor Before you search');
    } else if (this.state.activeKey === 2 && productinfo) {
      this.setState(
        { POStatus: poStatus },
        () => {
          this.fetchListWithFilters()
        }
      );
    }
  }

  fetchListWithFilters = (selectedWarehouse) => {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    const productinfo = this.state.filterProductID;
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const addtionalParams = {
      warehouse: selectedWarehouse ? selectedWarehouse : this.props.selectedWarehouse.value,
      Company_id: this.props.selectedCompany.value,
    };
    if (isOCM) {
      addtionalParams.IsTransfer = false;
      addtionalParams.IsRelocation = false;
    }
    if (this.state.orderType) {
      addtionalParams[this.state.orderType] = true;
    }
    if (this.state.activeKey === 1 && (this.props.Vendor_id || (isLAP || isUSPrideMulti || isAPD) && !this.props.Vendor_id) ) {
      this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, this.props.Vendor_id, null, addtionalParams);
    } else if (!((isLAP || isUSPrideMulti || isAPD) || isGGI) && this.state.activeKey === 1 && !this.props.Vendor_id) {
      alert('Please Select a Vendor Before you search');
    } else if (this.state.activeKey === 2 && productinfo) {
      this.props.fetchPurchasePerformanceByFilter(this.state.days, fromDate, toDate, 'show', this.state.POStatus, null, productinfo, addtionalParams);
    }
  }

  handleFetchPurchasingPerformanceByProduct = (ProductNum) => {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    this.setState({ filteredByItem: true, filterProductID: ProductNum }, () => {
      this.fetchListWithFilters();
    });
    // this.props.fetchPurchasePerformanceByFilter(this.props.Days, fromDate, toDate, 'show', this.state.POStatus, null, ProductNum);
  }

  openShowInventory(event) {
    if (!(this.props.allProducts) || (this.props.allProducts == '')) {
      return;
    }
    switch (event.charCode) {
      case 13: // ENTER
        event.preventDefault();
        this.setState({ showInventoryOpen: true });
        break;
    }
  }


  closeShowInventory(value) {
    this.setState({ showInventoryOpen: false });
  }

  selectInventoryInfo(selectedInventoryRow) {
    this.setState({ ProductNum: selectedInventoryRow });
  }

  setUnitPrice(unitPrice) {
  }

  setAllProductQuantity(quantity) {
  }

  renderTable() {
    const tableHeight = (window.innerHeight < 930) ? 300 : 300;
    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
      return (
        <div id="spinner" style={{ minHeight: tableHeight }}>
          <Spinner />
        </div>
      );
    } else
    if (this.props.purchasingPerformanceError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.purchasingPerformance);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const purchasingPerformance = Object.assign({}, this.state.purchasingPerformance, { sortColumn, sortDirection });
      this.setState({ purchasingPerformance });
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx != -1) {
        const rows = getRows();
        this.setState({ rows, selectedRows: [rows[rowIdx]] });
        this.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
      }
    };

    const onRowsSelected = (rows) => {
      let newRows = this.state.purchasingPerformance.rows;
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: newRows };
      this.setState({ purchasingPerformance });
    }
    const onRowsDeselected = (rows) => {
      let newRows = this.state.purchasingPerformance.rows;
      rows.map(r => {
        newRows[r.rowIdx].isSelected = false;
      });
      const purchasingPerformance = { ...this.state.purchasingPerformance, rows: newRows };
      this.setState({ purchasingPerformance });
    }
    // Column difinition
    const columns = [
      {
        key: 'PONum',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      ...(isLAP || isUSPrideMulti || isAPD) ? [
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorName',
          name: <Translate value="vendor_name" />,
          resizable: true,
          sortable: true,
          width: 140,
          filterable: true,
        },
      ]:[],
      {
        key: 'OrderDate',
        name: <Translate value="order_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="order_total" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="order_final" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveDate',
        name: <Translate value="rcv_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="rcv_total" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveFinalPrice',
        name: <Translate value="rcv_final" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: CashFormatter,
      },
      ...(isLAP || isUSPrideMulti || isAPD) ? [
        {
          key: 'ReturnFinalPrice',
          name: <Translate value="return_final_price" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
        },
        {
          key: 'LastReturnDate',
          name: <Translate value="rtn_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: DateFormatter,
        },
      ]:[],
      {
        key: 'PurchaseStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 110,
        formatter: ({ value }) => (
          <div>
            {isVAK ? value === 'Placed' ? <Translate value="po_placed" /> : <Translate value={value} /> : value}
          </div>
        ),
      },
      {
        key: 'Purchaser',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
    ];

    // React Table Purchase Order Full Table
    return (
      <Col sm={12}>
        {(getSize() === 0) && (<span className="alert-danger"><Translate value="no_data_found" /></span>)}
        <div className="react-table-purchasing-performance" id="PurchasingPerformance-dataGrid1">
          <ReactDataGrid
            enableRowSelect={(isLAP || isUSPrideMulti || isAPD) ? "multi" : "single"}
            onGridSort={handleGridSort}
            columns={columns}
            rowHeight={25}
            headerRowHeight={45}
            onRowClick={onRowClick}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            minHeight={tableHeight}
            rowSelection = {{
              showCheckbox: true,
              enableShiftSelect: true,
              onRowsSelected,
              onRowsDeselected,
              selectBy: {
                isSelectedKey: "isSelected",
              },
            }}
          />
        </div>
      </Col>
    );
  }


  renderProductsTableList() {
    if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner />;
    else if (this.props.purchaseOrderListError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}
          </div>
        </ContentWrapper>);
    }

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.purchaseOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.purchaseOrderDetail, { sortColumn, sortDirection });
      this.setState({ purchaseOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: {} };
      this.setState({ purchaseOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.purchaseOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: newFilters };
      this.setState({ purchaseOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, selectedRows: rows };
      this.setState({ purchaseOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const columns = [
      ...isOLG ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'OrderQuantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderUnitPrice',
        name: <Translate value="order_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'OrderTotalPrice',
        name: <Translate value="order_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(isLAP || isUSPrideMulti || isAPD) ? [
        {
          key: 'Rtn_Quantity',
          name: <Translate value="rtn_qty" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'Rtn_Weights',
          name: <Translate value="rtn_weight" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'Rtn_Total_price',
          name: <Translate value="return_final_price" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
        },
        {
          key: 'Rtn_LastDate',
          name: <Translate value="rtn_date" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: DateFormatter,
        },
      ]:[],
    ];

    // React Table Purchase Order Details
    return (
      <Col xs={12}>
        <div className="recat-customizer" id="PurchasingPerformance-dataGrid2">
          <ReactDataGrid
            onGridSort={handleGridSort}
            onAddFilter={handleFilterChange}
            onClearFilters={onClearFilters}
            columns={columns}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            rowHeight={25}
            headerRowHeight={45}
            minHeight={tableHeight}
            onRowSelect={onRowSelect}
          />
        </div>
      </Col>
    );
  }

  renderByProductTable() {
    const tableHeight = (window.innerHeight < 930) ? 470 : 470;

    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) {
      return (
        <div id="spinner" style={{ minHeight: tableHeight }}>
          <Spinner />
        </div>
      );
    } else if (this.props.purchasingPerformanceError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.purchasingPerformanceByProducts);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const purchasingPerformanceByProducts = Object.assign({}, this.state.purchasingPerformanceByProducts, { sortColumn, sortDirection });
      this.setState({ purchasingPerformanceByProducts });
    };

    // Column difinition
    const columns = [
      {
        key: 'PONum',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'OrderDate',
        name: <Translate value="order_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'VendorNum',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 130,
      },
      ...isSUN ? [{
        key: 'Vendor',
        name: <Translate value="vendor" />,
        resizable: true,
        sortable: true,
        width: 130,
      }] : [],
      {
        key: 'Quantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
      },
      {
        key: 'TotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        sortable: true,
        width: 60,
      },
      {
        key: 'FOBUnitPrice',
        name: <Translate value="order_unit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="order_total" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveDate',
        name: <Translate value="rcv_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
      },
      {
        key: 'ReceiveQuantity',
        name: <Translate value="rcv_qty" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      ...(isLAP || isUSPrideMulti || isAPD) ? [{
        key: 'RcvWT',
        name: <Translate value="rcv_wt" />,
        resizable: true,
        sortable: true,
        width: 80,
      }] : [],
      {
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 130,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="rcv_total" />,
        resizable: true,
        sortable: true,
        width: 60,
        formatter: CashFormatter,
      },
      ...(isLAP || isUSPrideMulti || isAPD) ? [{
        key: 'ReturnQty',
        name: <Translate value="rtn_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
      }, {
        key: 'ReturnWT',
        name: <Translate value="rtn_weight" />,
        resizable: true,
        sortable: true,
        width: 60,
      }, {
        key: 'ReturnFinalPrice',
        name: <Translate value="return_final_price" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: CashFormatter,
      }, {
        key: 'LastReturnDate',
        name: <Translate value="rtn_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: DateFormatter,
      }] : [],
      {
        key: 'Purchaser',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
    ];

    // React Table Purchase Order Full Table
    return (
      <Row>
        <Col sm={12}>
          {(getSize() === 0) && (<span className="alert-danger"><Translate value="no_data_found" /></span>)}
          <div className="react-table-purchasing-performance-by-product" id="PurchasingPerformance-dataGrid3">
            <ReactDataGrid
              enableCellSelect
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.handleFetchPurchasingPerformanceByProduct}
            setProductNum={this.selectInventoryInfo}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            let purchasingPerformanceByProducts = { ...this.state.purchasingPerformanceByProducts, rows: [], selectedInventoryRow: [], sortColumn: null, sortDirection: null, selectedIndexes: [] };
            this.setState({
              filteredByItem: false,
              suggestValue: '',
              filterProductID: null,
              totalPriceByProd: 0,
              totalQtyByProd: 0,
              receiveTotalPriceByProd: 0,
              receiveTotalQtyByProd: 0,
              purchasingPerformanceByProducts
            });
          }}
        />
      </div>
    );
  }

  getDateByDays = (days, fromDate, toDate) => {
    let dateRange = -1;
    if (days != null) { dateRange = days; }
    const date = {
      fromDate: '',
      toDate: '',
    };
    let postingDateGT = fromDate || '1900-01-01';
    let postingDateLT = toDate || '3000-01-01';
    if (dateRange != -1) {
      postingDateLT = moment().format('YYYY-MM-DD');
      if (dateRange === '1') {
        postingDateGT = postingDateLT;
      } else if (dateRange === '7') {
        postingDateGT = moment().subtract('7', 'days').format('YYYY-MM-DD');
      } else if (dateRange == '30') {
        postingDateGT = moment().subtract('30', 'days').format('YYYY-MM-DD');
      } else if (dateRange == '90') {
        postingDateGT = moment().subtract('90', 'days').format('YYYY-MM-DD');
      }
    }
    date.fromDate = postingDateGT;
    date.toDate = postingDateLT;
    return date;
  }

  handleTypeFilterChange = (orderType) => {
    this.setState({
      orderType,
    }, () => {
      this.fetchListWithFilters();
    });
  }

  renderOrderTypeRadio = () => {
    if (!isOCM) return null;

    const config = {
      content: [
        {
          option: null,
          id: 'normal-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'normal',
        },
        {
          option: 'IsRelocation',
          id: 'relocated-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'relocated',
        },
        {
          option: 'IsTransfer',
          id: 'transfer-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'transfer',
        }
      ],
      value: this.state.orderType,
      handleOnClick: this.handleTypeFilterChange,
      type: 'buttons',
    }

    return (
      <Row>
        <Col xs={2}>
          <h3 className="filter-title">
            <Translate value="order_type" />
            <span className="colon">:</span>
          </h3>
        </Col>
        <Col xs={10}>
          <div id="statusFilterRadios" className="form-horizontal">
            {genericRadioFilter(config)}
          </div>
        </Col>
      </Row>
    )
  }

  renderTotalQuantityField = () => {
    if (isOCM) {
      return <Row style={{marginTop: '10px'}}>
        <label className="col-xs-4"><Translate value="total_qty" /></label>
        <Col xs={5}>
          <Field name="SumPOQty" component={DisabledInputField} placeholder={this.state.totalQtyByProd} />
        </Col>
      </Row>;
    }
  }

  renderReceivedTotalQuantityField = () => {
    if (isOCM) {
      return <Row style={{marginTop: '10px'}}>
        <label className="col-xs-5"><Translate value="rcv_total_qty" /></label>
        <Col xs={5}>
          <Field name="SumPOQtyFinal" component={DisabledInputField} placeholder={this.state.receiveTotalQtyByProd} />
        </Col>
      </Row>;
    }
  }

  render() {
    const createDialogInventoryStyle = {
      height: '700px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };
    const renderByProduct = (<span className="tab-title-medium"><Translate value="by_product" /></span>);
    const renderByPO = (<span className="tab-title-medium"><Translate value="by_po" /></span>);
    const vendorOptions = this.getVendorOptions();
    let POStatus = this.state.POStatus;
    const days = this.state.days;
    let product_info = this.state.ProductNum;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let print_url = '';
    let excel_url = '';
    let excel_details_url = ''
    if (this.state.fromDate) {
      fromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate) {
      toDate = this.formatDate(this.state.toDate);
    }
    const dates = toFromDates(days, fromDate, toDate);
    fromDate = dates.fromDate;
    toDate = dates.toDate;
    let Vendor_id = this.props.Vendor_id;
    if (Vendor_id) {
      Vendor_id = Vendor_id.value || Vendor_id;
      if ((isLAP || isUSPrideMulti || isAPD)) {
        Vendor_id = `${Vendor_id}`;
      } else {
        Vendor_id = `${Vendor_id}/`;
      }
    } else {
      Vendor_id = '';
    }
    if (POStatus) {
      POStatus = POStatus.value || POStatus;
      POStatus = `&PurchaseStatus=${POStatus}`;
    } else {
      POStatus = '&PurchaseStatus=All';
    }
    if (product_info) {
      product_info = product_info.value || product_info;
      product_info = `${product_info}/`;
    } else {
      product_info = '';
    }
    if (this.state.activeKey == 1) {
      fromDate = `OrderDate__gte=${fromDate}`;
      toDate = `OrderDate__lte=${toDate}`;
      let connectUrl = `?${fromDate}&${toDate}${POStatus
        }&Bearer=${localStorage.getItem('token')}`
      if ((isLAP || isUSPrideMulti || isAPD)) {
        let selectRows = this.state.purchasingPerformance.rows.filter(item => item.isSelected)
        let po_ids = ''
        let po_ids_arr = []
        print_url = `${ROOT_URL}v1/purchase/performance/Vendor/print/${connectUrl}`
        excel_url = `${ROOT_URL}v1/purchase/performance/Vendor/export/${connectUrl}`;
        excel_details_url = `${ROOT_URL}v1/purchase/performance/Vendor/export_details/${connectUrl}`;
        if (selectRows.length) {
          selectRows.map(item => {
            po_ids_arr.push(item.PurchaseOrder_id)
          })
          po_ids = po_ids_arr.join(',')
          print_url += `&po_ids=${po_ids}`
          excel_url += `&po_ids=${po_ids}`;
          excel_details_url += `&po_ids=${po_ids}`;
        }
        if (Vendor_id) {
          print_url += `&vendor_id=${Vendor_id}`
          excel_url += `&vendor_id=${Vendor_id}`
          excel_details_url  += `&vendor_id=${Vendor_id}`
        }
      } else {
        print_url = `${ROOT_URL}v1/purchase/performance/Vendor_id/${
          Vendor_id}print/${connectUrl}`;
        excel_url = `${ROOT_URL}v1/purchase/performance/Vendor_id/${
          Vendor_id}export/${connectUrl}`;
        if (isGGI) {
          const params = {
            warehouse: `warehouse=${this.props.selectedWarehouse.value}`,
            Company_id: `Company_id=${this.props.selectedCompany.value}`,
          };
          print_url += `&${Object.values(params).join('&')}`;
          excel_url += `&${Object.values(params).join('&')}`;
        }
      }
    } else {
      fromDate = `OrderDate__gte=${fromDate}`;
      toDate = `OrderDate__lte=${toDate}`;
      print_url = `${ROOT_URL}v1/purchase/performance/ProductNum/${
        product_info}print/?${fromDate}&${toDate}${POStatus
      }&Bearer=${localStorage.getItem('token')}`;
      excel_url = `${ROOT_URL}v1/purchase/performance/ProductNum/${
        product_info}export/?${fromDate}&${toDate}${POStatus
      }&Bearer=${localStorage.getItem('token')}`;
      const params = {
        warehouse: `warehouse=${this.props.selectedWarehouse.value}`,
        Company_id: `Company_id=${this.props.selectedCompany.value}`,
      };
      if (isOCM) {
        params.IsTransfer = `IsTransfer=false`;
        params.IsRelocation = `IsRelocation=false`;
        if (this.state.orderType) {
          params[this.state.orderType] = `${this.state.orderType}=true`;
        }
        print_url += `&${Object.values(params).join('&')}`;
        excel_url += `&${Object.values(params).join('&')}`;
      }
      if (isGGI) {
        print_url += `&${Object.values(params).join('&')}`;
        excel_url += `&${Object.values(params).join('&')}`;
      }
    }
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        print_url += `&time_zone=${zone}&time_diff=${time}`;
      } else {
        print_url += `&time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="purchase_performance" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="purchasing-performance">
          {/* Date Range Pickers */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                {this.renderOrderTypeRadio()}
                <Row>
                  <Col xs={2}>
                    <h3 className="filter-title"><Translate value="order_status" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {
                        genericRadioFilter({
                          content: [
                            {
                              option: 'All',
                              id: 'all-radio-filter',
                              name: 'statusFilterRadios',
                              labelName: 'all',
                            },
                            {
                              option: 'Placed',
                              id: 'placed-radio-filter',
                              name: 'statusFilterRadios',
                              labelName: isVAK ? 'po_placed' : 'placed',
                            },
                            {
                              option: 'Received',
                              id: 'received-radio-filter',
                              name: 'statusFilterRadios',
                              labelName: 'received',
                            },
                          ],
                          value: this.state.POStatus,
                          handleOnClick: this.fetchPurchasingPerformanceByStatus,
                          type: 'buttons',
                        })
                      }
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title"><Translate value="order_date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={10}>
                    {
                      dateFilterRadios({
                        handleOnClick: this.fetchPurchasingPerformanceByDays,
                        setFromDate: this.setFromDate,
                        setToDate: this.setToDate,
                        setToRangeSearch: this.setToRangeSearch,
                        FromDate: this.state.fromDate,
                        ToDate: this.state.toDate,
                        Days: this.state.days,
                      })
                    }
                  </Col>
                </Row>
              </Panel>
               {/* End Date Range Pickers */}
            </Col>
          </Row>

          <Tabs activeKey={this.state.activeKey} justified onSelect={this.handleSelect}>
            <Tab eventKey={1} title={renderByPO} style={{ height: '350px' }}>
              <Row className="table-filters-purchasing-performance">
                <Col xs={(isLAP || isUSPrideMulti || isAPD) ? 4 : 3}>
                  <ButtonToolbar>
                    <Button bsStyle="primary" href={print_url} disabled={(!(isLAP || isUSPrideMulti || isAPD) && !Vendor_id) || !this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-print" /><Translate value="print" />
                    </Button>
                    <Button bsStyle="success" href={excel_url} disabled={(!(isLAP || isUSPrideMulti || isAPD) && !Vendor_id) || !this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-download" /><Translate value="excel" />
                    </Button>
                    {
                      (isLAP || isUSPrideMulti || isAPD) && <Button bsStyle="success" href={excel_details_url} disabled={!this.state.purchasingPerformance.rows.length || !checkPermission('print_purchase_performance')}>
                      <em className="fa fa-download" /><Translate value="excel_with_details" />
                    </Button>
                    }
                  </ButtonToolbar>
                </Col>
                <Col xs={4}>
                  <label className="col-xs-4"><Translate value="vendor" /></label>
                  <Col xs={8}>
                    <Field name="Vendor_id" component={Selection} options={vendorOptions} matchPos="any" />
                  </Col>
                </Col>
                <Col xs={3}>
                  <label className="col-xs-4"><Translate value="total_price" /></label>
                  <Col xs={5}>
                    <Field name="SumPO" component={DisabledInputField} placeholder={this.state.totalPriceByPO} />
                  </Col>
                </Col>
                <Col xs={(isLAP || isUSPrideMulti || isAPD) ? 2 : 3}>
                  <label className="col-xs-4"><Translate value="final_dollarsign" /></label>
                  <Col xs={5}>
                    <Field name="SumPOFinal" component={DisabledInputField} placeholder={this.state.finalPriceByPO} />
                  </Col>
                </Col>
              </Row>
              <br />
              <Row>
                { this.renderTable() }
              </Row>
              <br />
              <Row>
                { this.renderProductsTableList() }
              </Row>
            </Tab>
            <Tab eventKey={2} title={renderByProduct}>
              <Row className="table-filters-purchasing-performance" style={{ display: 'flex' }}>
                <Col xs={2}>
                  <ButtonToolbar>
                    <Button bsStyle="primary" href={print_url} disabled={!this.state.purchasingPerformanceByProducts.rows.length}>
                      <em className="fa fa-print" /><Translate value="print" />
                    </Button>
                    <Button bsStyle="success" href={excel_url} disabled={!this.state.purchasingPerformanceByProducts.rows.length}>
                      <em className="fa fa-download" /><Translate value="excel" />
                    </Button>
                  </ButtonToolbar>
                </Col>
                <Col xs={6} className="p0">
                  <div id="autosuggest-div">
                      <Row style={{ height: '30px' }}>
                        <Col xs={12}>
                          <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          {this.renderAutoSuggest()}
                        </Col>
                      </Row>
                    </div>
                </Col>
                {/*<Col xs={1}>
                  <Button
                    bsStyle="primary"
                    className="search-btn"
                    type="submit"
                    style={{ marginTop: '15px' }}
                    onClick={() => { this.fetchPurchasingPerformance(this.state.Days); }}
                  >
                    <em className="fa fa-search" />
                  </Button>
                </Col>*/}
                <Col xs={3}>
                  <Row>
                    <label className="col-xs-4"><Translate value="total_price" /></label>
                    <Col xs={5}>
                      <Field name="SumPO" component={DisabledInputField} placeholder={this.state.totalPriceByProd} />
                    </Col>
                  </Row>
                  {this.renderTotalQuantityField()}
                </Col>
                <Col xs={3}>
                  <Row>
                    <label className="col-xs-4"><Translate value="rcv_total" /></label>
                    <Col xs={5}>
                      <Field name="SumPOFinal" component={DisabledInputField} placeholder={this.state.receiveTotalPriceByProd} />
                    </Col>
                  </Row>
                  {this.renderReceivedTotalQuantityField()}
                </Col>
              </Row>
              <br />
              { this.renderByProductTable() }
            </Tab>
          </Tabs>
        </Grid>

        {/* Inventory List */}
        <SkyLightStateless
          dialogStyles={createDialogInventoryStyle}
          isVisible={this.state.showInventoryOpen}
          onCloseClicked={
            this.closeShowInventory}
          title="Select Inventory"
        >
          <InventoryInfo
            searchValue={this.props.allProducts}
            searchType={this.props.searchType}
            closeShowInventory={this.closeShowInventory}
            selectInventoryInfo={this.selectInventoryInfo}
            setAllProducts={this.props.setAllProducts}
            setUnitPrice={this.setUnitPrice}
            setAllProductQuantity={this.setAllProductQuantity}
            form="purchasingPerformance"
          />
        </SkyLightStateless>
        {/* End Inventory List */}
      </ContentWrapper>
    );
  }
}

export default PurchasingPerformance;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasingPerformance.jsx